import htmlBlock from './htmlBlock';

export default htmlBlock;
